import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    HostBinding,
} from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { LoginFormComponent } from '@spartacus/user/account/components';
import { VscaAuthService } from '../../../../../../../core/auth/user-auth/facade/vsca-auth.service';
import { DataLayerService } from '../../../../../../shared/services/data-layer.service';
import { VscaLoginFormComponentService } from './vsca-login-form-component.service';
@Component({
    selector: 'vsca-cx-login-form',
    templateUrl: './vsca-login-form.component.html',
    styleUrls: ['./vsca-login-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VscaLoginFormComponent extends LoginFormComponent {

  constructor(
    protected readonly service: VscaLoginFormComponentService,
    private readonly route: RoutingService,
    protected readonly authService: VscaAuthService,
    private readonly ref: ChangeDetectorRef,
    private readonly dataLayerService: DataLayerService
  ) {
    super(service);
    this.service.authorize();
  }

  @HostBinding('class.user-form') style = true;


  onSubmit(): void {    
    this.dataLayerService.loginDataLayer();
    super.onSubmit();
  }

  gotoLoginHelp() {
    this.route.goByUrl('/login/loginhelp');
  }

  goToCustomerRegister(): void {
    window.location.href = 'dz/fr_DZ/DZD/customer-register';
  }
  
}
